module.exports = __webpack_public_path__ + "img/scale_grey.c800d2ad.svg";